export const iconFontAwesomeMediaplaybackMusic = (
	<i className="fa-solid fa-music"></i>
);
